const base = '/filters/';
export const FILTERS = {
    DIRECTIVE_FILTER : `${base}DIRECTIVE_FILTER`,
    TITULAR_FILTER: `${base}TITULAR_FILTER_FE`,
    PRESIDENCY_PERMANENT_COMMISSION: `${base}PRESIDENCY_PERMANENT_COMMISSION`,
};
